import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {SCROLL_TO_PREFIX} from '@/constants';
import {GlobalWindow} from '@/types';

const SCROLL_TIMEOUT_IN_MS = 100;

export class ScrollService {
  constructor(private readonly globalWindow: GlobalWindow) {}

  public scrollPageToTop(): void {
    this.globalWindow.scrollTo(0, 0);
  }

  scrollToElement = (id: string): void => {
    // вызываем скролл в setTimeout, чтобы в Safari скролл выполнился как smooth
    setTimeout(() => {
      const element = this.globalWindow.document.getElementById(`${SCROLL_TO_PREFIX}${id}`);
      if (element === null) return;
      element.scrollIntoView({block: 'center', behavior: 'smooth'});
    }, SCROLL_TIMEOUT_IN_MS);
  };
}

injected(ScrollService, DI_TOKENS.globalWindow);
